module.exports = __webpack_public_path__ + "static/media/sound_2.11c4ab3f.mp3";